import type { AppRole } from "@/lib/marketplace-auth";

export type Persona = "renter" | "host" | "fleet_manager" | "buyer" | "experiences" | "unknown";

/**
 * Derives the active persona from a pathname.
 * Used to segment PostHog sessions and experiments without requiring auth.
 */
export function getPersonaFromPath(pathname: string): Persona {
  if (
    pathname.startsWith("/buy-a-van") ||
    pathname.startsWith("/builder")
  ) return "buyer";

  if (
    pathname.startsWith("/manage-a-fleet") ||
    pathname.startsWith("/fleet-manager") ||
    pathname.startsWith("/find-fleet-manager")
  ) return "fleet_manager";

  if (
    pathname.startsWith("/host") ||
    pathname.startsWith("/list-your-van") ||
    pathname.startsWith("/host-a-van") ||
    pathname.startsWith("/marketplace/create-listing") ||
    pathname.startsWith("/marketplace/stripe-setup-guide")
  ) return "host";

  if (
    pathname.startsWith("/rent-a-van") ||
    pathname.startsWith("/rentals") ||
    pathname.startsWith("/marketplace/vehicle") ||
    pathname.startsWith("/marketplace/book") ||
    pathname.startsWith("/marketplace/trip") ||
    pathname.startsWith("/marketplace/messages") ||
    pathname.startsWith("/marketplace/review") ||
    pathname.startsWith("/marketplace/dashboard") ||
    pathname.startsWith("/marketplace/rent") ||
    pathname.startsWith("/how-it-works")
  ) return "renter";

  if (
    pathname === "/" ||
    pathname.startsWith("/sprinter-vans") ||
    pathname.startsWith("/dallas-") ||
    pathname.startsWith("/dfw-") ||
    pathname.startsWith("/plano-") ||
    pathname.startsWith("/frisco-") ||
    pathname.startsWith("/arlington-") ||
    pathname.startsWith("/addison-") ||
    pathname.startsWith("/las-colinas-") ||
    pathname.startsWith("/blog")
  ) return "experiences";

  return "unknown";
}

/**
 * Maps a Supabase AppRole to a PostHog persona.
 * Auth role takes precedence over route-derived persona for identified users.
 */
export function getPersonaFromRole(roles: AppRole[]): Persona | null {
  if (roles.includes("fleet_manager")) return "fleet_manager";
  if (roles.includes("host")) return "host";
  if (roles.includes("renter")) return "renter";
  return null;
}
